<template>
  <div>
    <calendar />
  </div>
</template>

<script>
import Calendar from './profile/Calendar';

// @vuese
// Strona główna (dashboard)
// @group views
export default {
  components: { Calendar }
};
</script>